<script setup lang="ts">
import type { BrokerAboutSectionProps } from '.';

import { useEvents } from '~/composables/events/useEvents';
import { MixpanelProps } from '~/core/service/mixpanel';
import { useAgentProfileStore } from '~/store/agentProfileStore';
import { storeToRefs } from 'pinia';

import { BrokerAbout } from '~/components/BrokerAbout';

const SECTION_NAME = 'agent profile about';

const props = withDefaults(defineProps<BrokerAboutSectionProps>(), {
	isLoading: false
});

const route = useRoute();
const agentProfileStore = useAgentProfileStore();
const { profile } = storeToRefs(agentProfileStore);
const { trackSeeMoreClicked } = useEvents();

const hasContent = computed<boolean>(() => Boolean(profile.value?.bio?.trim()));

function handleSeeMoreClick(): void {
	trackSeeMoreClicked({
		[MixpanelProps.CURRENT_PAGE]: route.fullPath,
		[MixpanelProps.SECTION_NAME]: SECTION_NAME
	});
}

defineExpose({ hasContent });
</script>

<template>
	<BrokerAbout
		:class="props.class"
		:is-loading="isLoading"
		:bio="profile?.bio"
		@see-more-click="handleSeeMoreClick"
	/>
</template>
